<script setup lang="ts">
import type { Order } from '../model/interfaces'

import { faArrowsRotate, faArrowUpRightFromSquare, faFileInvoice } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useOrderActions } from '../model/order-actions.hook'

defineOptions({
  name: 'OrderRowActions',
})

const props = withDefaults(defineProps<{
  order: Order
  /** Off on the customer's own Orders tab — the admin is already on that customer. */
  withCustomer?: boolean
}>(), {
  withCustomer: true,
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  hasCustomer,
  canManage,
  canCustomiseInvoice,
  toggle,
  openOrder,
  openCustomer,
  openInvoice,
  syncOrder,
} = useOrderActions({
  order: computed(() => props.order),
})
</script>

<template>
  <div
    ref="containerRef"
    class="order-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for order #${order.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="order-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="View order"
          color="blue"
          :prepend-icon="faArrowUpRightFromSquare"
          @click="openOrder"
        />
        <AppDropdownItem
          v-if="hasCustomer && withCustomer"
          text="View customer"
          color="blue"
          :prepend-icon="faArrowUpRightFromSquare"
          @click="openCustomer"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Sync order"
          color="blue"
          :prepend-icon="faArrowsRotate"
          @click="syncOrder"
        />
        <AppDropdownItem
          v-if="canCustomiseInvoice"
          text="Customise invoice"
          color="blue"
          :prepend-icon="faFileInvoice"
          @click="openInvoice"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./OrderRowActions.scss" />
